var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g({staticClass:"custom-text-field",attrs:{"value":_vm.value,"label":_vm.label,"filled":"","height":"64","type":_vm.type,"rules":_vm.rules,"maxlength":_vm.maxLength,"validate-on-blur":_vm.validateOnBlur,"readonly":_vm.readonly,"disabled":_vm.disabled,"autocomplete":_vm.autocomplete}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }